import {
  CER_LOADING,
  SEND_CERTIFICATE,
  VERIF_SANITARIO,
  SEND_SANITARIO,
  DOWNLOAD_CERTIFICATE,
  CERTIFICATE_DOWNLOAD_ERROR,
  CERTIFICATE_API_NO_PDF,
} from "../actions/CertificateActions";

const initialState = {
  addRequestID: 0,
  loading: false,
  loadingType: null,
  add: false,
  downloadSuccess: false,
  downloadError: false,
  downloadErrorMessage: "",
  Sanitario: false,
  addSanitario: false,
};

const CertificateReducer = function (state = initialState, action) {
  switch (action.type) {
    case CER_LOADING: {
      return {
        ...state,
        loading: true,
        loadingType: action.certificateType || null,
        add: false,
        downloadSuccess: false,
        downloadError: false,
        Sanitario: false,
        addSanitario: false,
      };
    }
    case SEND_CERTIFICATE: {
      return {
        ...state,
        addRequestID: action.data,
        loading: false,
        loadingType: null,
        add: true,
        Sanitario: false,
        addSanitario: false,
      };
    }
    case DOWNLOAD_CERTIFICATE: {
      return {
        ...state,
        loading: false,
        loadingType: null,
        downloadSuccess: true,
        downloadError: false,
        add: false,
      };
    }
    case CERTIFICATE_DOWNLOAD_ERROR: {
      return {
        ...state,
        loading: false,
        loadingType: null,
        downloadSuccess: false,
        downloadError: true,
        downloadErrorMessage: action.error || "",
      };
    }
    case CERTIFICATE_API_NO_PDF: {
      return {
        ...state,
        loading: false,
        loadingType: null,
      };
    }
    case VERIF_SANITARIO: {
      return {
        ...state,
        loading: false,
        loadingType: null,
        add: false,
        Sanitario: action.data,
        addSanitario: false,
      };
    }
    case SEND_SANITARIO: {
      return {
        ...state,
        loading: false,
        loadingType: null,
        add: false,
        Sanitario: false,
        addSanitario: action.data,
      };
    }
    default: {
      return state;
    }
  }
};

export default CertificateReducer;
